import React, { useEffect } from "react";
import { Popper, Paper, Button } from "@mui/material";

const CustomPopper = ({ open, anchorEl, cajamodal, handleClose, funcionVista }) => {
  useEffect(() => {
    const handleOutsideClick = (event) => {
      const key = event.target.getAttribute("data-key");
      if (key) {
        localStorage.setItem("view", key);
        funcionVista();
      }
      if (anchorEl && !anchorEl.contains(event.target)) {
        handleClose(); 
      }
    };

    if (open) {
      document.addEventListener("mousedown", handleOutsideClick);
    }
    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
    };
  }, [open, anchorEl, handleClose]);

  return (
    <Popper open={open} anchorEl={anchorEl} placement="right-start" 
      modifiers={[
        {
          name: "preventOverflow",
          options: {
            boundary: "window",
          },
        },
      ]}
      style={{ zIndex: 1300 }} 
    >
      <Paper sx={{ p: 2, boxShadow: 3, bgcolor: "#aaaaaa", borderRadius: 2, width: 200, }} >
        {cajamodal.map((boton, index) => (
          <Button key={index} data-key={boton.id} variant="contained"
            sx={{ mt: 1, display: "block", width: "100%", fontSize:12, lineHeight: 1.2 }} >
            {boton.label}
          </Button>
        ))}
      </Paper>
    </Popper>
  );
};

export default CustomPopper;
